export const PRIVACY_POLICY = `Privacy Policy

Last Updated: January 2, 2026

1. INTRODUCTION

Brixen Credit LLC ("we," "us," or "our") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, use our credit repair software ("SaaS"), or engage our concierge services. By using our Site or Services, you consent to the data practices described in this policy.

2. INFORMATION WE COLLECT

We collect information necessary to facilitate credit analysis and dispute resolution:

Personal Identification Information: Name, email address, phone number, physical address, date of birth, Social Security Number (SSN), and identity document copies (Driver's License, Passport) required to validate your identity with credit bureaus.

Credit & Financial Information: Credit reports (imported from TransUnion, Equifax, Experian), payment history, negative account details (collections, late payments, bankruptcies), and monitoring service credentials if provided by you.

Technical Usage Data: IP address, browser type, and in-app behavior (letter generation, downloads), collected automatically via cookies.

3. HOW WE USE YOUR INFORMATION

We use the information we collect to:

Provide Services: Analyze credit reports, identify negative items, generate AI-powered dispute letters, and manage physical mail delivery (if applicable).

Communication: Contact you via email, phone, SMS, or WhatsApp regarding your dispute status, credit alerts, or account updates.

Improvement: Train our AI algorithms to improve dispute effectiveness (using anonymized data).

Security: Verify your identity to comply with federal regulations and prevent fraud.

4. SHARING YOUR INFORMATION & MESSAGING DISCLOSURES

Sharing information is necessary to execute disputes, but we strictly protect your contact data:

Operational Data Sharing: We may share your personal data (such as dispute letters and identity proofs) with Credit Bureaus (TransUnion, Equifax, Experian) and Original Creditors solely for the purpose of processing your disputes.

Strict Mobile Data Policy:

Customer data is NOT shared with 3rd parties for promotional or marketing purposes.

Mobile opt-in and consent are NEVER shared with anyone for any purpose. Any information sharing mentioned elsewhere in this policy excludes mobile opt-in data.

Messaging Terms: By providing your phone number, you consent to receive text messages from BRIXEN CREDIT LLC or from our verified number regarding customer care and dispute updates. Consent is not a condition of purchase. Message frequency varies. Message & data rates may apply. You can reply STOP to unsubscribe at any time or HELP for assistance.

5. DATA STORAGE CONSENT

By accepting this policy, you expressly grant Brixen Credit LLC permission to digitally store copies of your credit reports, identity documents, and generated correspondence for the duration of your subscription to maintain your case history.

6. DATA SECURITY

We use bank-level SSL encryption and secure servers to protect your sensitive information (SSN and credit reports). However, no electronic transmission over the Internet is 100% secure.

7. CONTACT US

Brixen Credit LLC

390 NE 191st St Ste 8123, Miami, FL 33179

Phone: 786-627-9073

Email: info@brixencredit.com`

export const TERMS_CONDITIONS = `Terms & Conditions

Last Updated: January 2, 2026

1. AGREEMENT TO TERMS

These Terms and Conditions ("Terms") constitute a legally binding agreement between you ("Client" or "User") and Brixen Credit LLC ("we," "us," or "our"), concerning your access to and use of our credit repair software and related services. By registering or using the Site, you agree to be bound by these Terms.

2. NATURE OF SERVICES (DISCLAIMER)

Brixen Credit provides an AI-powered software platform ("SaaS") and assisted credit restoration services.

Not a Law Firm: Brixen Credit LLC does not provide legal advice. Our software uses algorithms based on credit laws (FCRA, FDCPA) to generate documents, but this does not substitute for legal counsel.

Self-Help Tool (DIY Plans): For software subscription plans, you are responsible for reviewing and sending the generated letters. We provide the tool; you execute the action.

3. RESULTS WARRANTY POLICY (CROA COMPLIANCE)

In compliance with the Credit Repair Organizations Act (CROA):

NO GUARANTEE OF RESULTS: We do not guarantee, nor can we guarantee, that your disputes will result in the removal of specific information or a specific increase in your credit score. Results vary by individual profile and bureau response.

Accurate Information: We cannot and do not promise to remove negative information that is accurate, complete, and verifiable, as credit bureaus have a legal right to report it (typically 7 years, or 10 for bankruptcies).

Timelines: Any timeframe mentioned (e.g., "45 days") is an estimate based on past experience, not a contractual promise of completion.

4. USER OBLIGATIONS

You agree to: (1) Provide true, accurate, and complete information; (2) NOT use the service to create false identities (Synthetic Fraud) or dispute information you know is correct with malicious intent; (3) Forward us any physical correspondence received from bureaus or creditors to update your file.

5. AUTHORIZATION

You authorize us and our systems to access your credit reports (via monitoring providers) and use your digital signature to generate dispute letters in your name addressed to credit bureaus and creditors.

6. MESSAGING COMPLIANCE (TCPA)

By providing your mobile number, you agree to receive automated messages (SMS/MMS) regarding your account.

Consent: Not a condition of purchase.

Opt-Out: Reply STOP to end messages at any time.

Liability: Carriers are not liable for delayed or undelivered messages.

7. LIMITATION OF LIABILITY

IN NO EVENT SHALL BRIXEN CREDIT LLC BE LIABLE FOR ANY INDIRECT, CONSEQUENTIAL, OR INCIDENTAL DAMAGES ARISING FROM YOUR USE OF THE SITE. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT PAID BY YOU IN THE LAST THREE (3) MONTHS OF SERVICE.

8. BINDING ARBITRATION & CLASS ACTION WAIVER

You agree that any dispute arising from these Terms shall be resolved exclusively through binding arbitration in Miami-Dade County, Florida. You waive your right to participate in a class action lawsuit against Brixen Credit LLC.

9. GOVERNING LAW

These Terms shall be governed by the laws of the State of Florida.

10. CONTACT US

Brixen Credit LLC

390 NE 191st St Ste 8123, Miami, FL 33179

Phone: 786-627-9073

Email: info@brixencredit.com`

export const REFUND_POLICY = `Refund Policy

Last Updated: January 2, 2026

1. RIGHT OF RESCISSION (3-DAY CANCELLATION)

You may cancel this transaction, without any penalty or obligation, within three (3) business days from the date the contract is signed or the service is purchased.

To cancel, you must notify us in writing via email at refunds@brixencredit.com before midnight of the third business day.

If you cancel within this period, any payments made will be returned within 10 days following receipt of your cancellation notice.

2. SERVICE REQUIREMENTS & ELIGIBILITY (MYSCOREIQ)

To receive our services, you must maintain an active credit monitoring subscription with MyScoreIQ at all times.

Brixen Credit LLC requires uninterrupted access to your credit report to analyze data and generate disputes. If your MyScoreIQ account is paused, cancelled, or the login credentials become invalid, we cannot perform the service.

Failure to maintain an active MyScoreIQ subscription constitutes a breach of your service agreement and voids any eligibility for refunds after the initial 3-day period.

3. NO GUARANTEE OF RESULTS

In compliance with the Credit Repair Organizations Act (CROA), Brixen Credit LLC does NOT guarantee specific results.

We cannot guarantee:

• The removal of any specific negative item.

• A specific increase in your credit score.

• A specific timeframe for results.

Results depend on the accuracy of the information reported by the bureaus and your individual credit profile. Consequently, we do not offer refunds based on the outcome of the disputes or the lack of score improvement.

4. GENERAL REFUND POLICY (AFTER 3 DAYS)

Due to the nature of our digital services and the immediate work performed upon onboarding:

• All subscription payments are non-refundable once the initial 3-day cancellation period has passed.

• Monthly subscription fees, setup fees, and document processing fees are final.

• You may cancel your subscription at any time to prevent future charges, but no prorated refunds will be issued for the current billing cycle.

5. NON-REFUNDABLE ITEMS

The following fees are never refundable under any circumstances:

• Third-Party Services: Payments made to MyScoreIQ or other monitoring services.

• Postage & Printing: Fees paid for "Done-For-You" printing or certified mail.

• Consultation Fees: Any one-time analysis fees once the service has been rendered.

6. CONTACT US

If you have any questions about this Refund Policy, please contact us:

Brixen Credit LLC

390 NE 191st St Ste 8123, Miami, FL 33179

Phone: 786-627-9073

Email: info@brixencredit.com`
